import React, { Component } from "react"

export default class ANIM10 extends Component {
  render() {
  return (
      <div className="portfoliosmalldetwrap">
        <div className="portdescwrap">
          <div className="portdesc">
            <p className="portdesctitle">Bric-a-ack</p>
            <p className="portdesctext">Collection of select 10 animations painstakingly hand drawn frame by frame in photoshop and composted in premiere pro in submission for <a href="http://www.fieldnotesjournal.org.uk/Submissions.html">FN002</a>. Inspired by the benign & malignant vices that adorned my isolation. Animations listed from 1 to 10:
            <a href="https://www.dropbox.com/s/owu73ubj3r0fvf6/9v_Ali_Razzak.gif?dl=0" target="_blank" rel="noopener noreferrer"> 1 </a> 
            <a href="https://www.dropbox.com/s/v21plo618t305vb/Apple_Ali_Razzak.gif?dl=0" target="_blank" rel="noopener noreferrer">2 </a> 
            <a href="https://www.dropbox.com/s/6448k4h59tg9zo0/Bell_Ali_Razzak.gif?dl=0" target="_blank" rel="noopener noreferrer">3 </a>  	
            <a href="https://www.dropbox.com/s/47ov0ikchw0jdzk/Candle_Melt_Ali_Razzak.gif?dl=0" target="_blank" rel="noopener noreferrer">4 </a>  	
            <a href="https://www.dropbox.com/s/474el2pp4kxxah2/Dust_Ali_Razzak.gif?dl=0" target="_blank" rel="noopener noreferrer">5 </a>  	
            <a href="https://www.dropbox.com/s/s4er5a7hpk2gfmt/Hangers_Ali_Razzak.gif?dl=0" target="_blank" rel="noopener noreferrer">6 </a>  	
            <a href="https://www.dropbox.com/s/dr7hyc5m8mva76y/Hourglass_Ali_Razzak.gif?dl=0" target="_blank" rel="noopener noreferrer">7 </a>  	
            <a href="https://www.dropbox.com/s/7wrmk2wxqkceqgv/Ice_Ali_Razzak.gif?dl=0" target="_blank" rel="noopener noreferrer">8 </a>  	
            <a href="https://www.dropbox.com/s/1072gho0xb3doam/Tap_Ali_Razzak.gif?dl=0" target="_blank" rel="noopener noreferrer">9 </a>  	
            <a href="https://www.dropbox.com/s/irs4p455jaghiq5/Tea_Ali_Razzak.gif?dl=0" target="_blank" rel="noopener noreferrer">10 </a>  	
            </p>
          </div>
        </div>
      </div>
  )
}
}

